import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
// import icpImg from './ICP.png';
import policeImg from './police.png';
import './Footer.css';

function Footer() {
  const { t } = useLanguage();
  const f = t.footer;
  const n = t.nav;

  return (
    <footer className='footer'>
      <div className='container'>
        <div className='footer-content'>
          <div className='footer-section'>
            <h3>{n.logoText}</h3>
            <p>{f.description}</p>
            {/* <div className="footer-social">
              <a href="#" aria-label="微信">📱</a>
              <a href="#" aria-label="微博">🌐</a>
              <a href="#" aria-label="邮箱">✉️</a>
            </div> */}
          </div>

          <div className='footer-section'>
            <h4>{f.quickLinks}</h4>
            <ul>
              <li>
                <Link to='/'>{n.home}</Link>
              </li>
              <li>
                <Link to='/about'>{n.about}</Link>
              </li>
              <li>
                <Link to='/services'>{n.services}</Link>
              </li>
              <li>
                <Link to='/pricing'>{n.pricing}</Link>
              </li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4>{f.serviceScope}</h4>
            <ul>
              <li>{f.domestic}</li>
              <li>{f.international}</li>
              <li>{f.warehouse}</li>
              <li>{f.supplyChain}</li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4>{f.contactUs}</h4>
            <ul className='footer-contact'>
              <li>📞 15521339259</li>
              <li>📧 cherry@fjhanyang.com</li>
              <li>📧 oversales@szshowjoy.com</li>
              <li>📍 {f.address}</li>
              <li>🕐 {f.hours}</li>
            </ul>
          </div>
        </div>

        <div className='footer-bottom'>
          <p>{f.copyright}</p>
          {/* <div className="footer-links">
            <a href="#">{f.privacy}</a>
            <span>|</span>
            <a href="#">{f.terms}</a>
            <span>|</span>
            <a href="#">{f.sitemap}</a>
          </div> */}

          <div className='footer-links'>
            <a
              href='https://beian.miit.gov.cn/'
              target='_blank'
              rel='noopener noreferrer'
            >
              {/* <img src={icpImg} alt="icp" /> */}
              粤ICP备2026035524号-1
            </a>
            <span className='footer-beian'>
              <img
                src={policeImg}
                alt='公安备案'
              />
              <a
                href='https://beian.mps.gov.cn/#/query/webSearch?code=44030002011853'
                rel='noreferrer'
                target='_blank'
              >
                粤公网安备44030002011853号
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
